import { useContext } from 'react';
import "./payment.css";
import FormButton from '../../formComponents/FormButton';
import { useNavigate } from 'react-router-dom';
import { SubscriptionContext } from '../../../../contextApi/SubscriptionContext';
import FormInput from '../../formComponents/FormInput';
import { AppContext } from '../../../../contextApi/ContextApi';

export default function Payment() {
    const {getTodayDate} = useContext(AppContext);
    const { paymentFlag, setCardName, cardName, setCardNumber, cardNumber, setExpiryDate, expiryDate, setCvv, cvv, handleCreateWebsite } = useContext(SubscriptionContext);
    const nav = useNavigate();

    const handleChangeNum = (val) => {
        let raw = val.replace(/\s/g, "");
        if (raw.length > 16) raw = raw.slice(0, 16);
        const formatted = raw.match(/.{1,4}/g)?.join(" ") || "";
        setCardNumber(formatted);
    };
    const handleChangeCVV = (val) => {
        let raw = val.replace(/\s/g, "");
        if (raw.length > 3) raw = raw.slice(0, 3);
        setCvv(raw);
    };
    
    return (
        <div className="payment-page" dir='rtl'>
                <FormInput id={"payment-form_cardName"} label={"שם בעל הכרטיס"} type={"text"} placeholder={"אבי כהן"} value={cardName} setText={setCardName} hasButton={false}/>
                <FormInput direction='ltr' id={"payment-form_cardNumber"} label={"מספר כרטיס האשראי"} type={"text"} placeholder={"1234 1234 1234 1234"} value={cardNumber} setText={handleChangeNum} hasButton={false}/>

                <FormInput id={"payment-form_cardCVV"} label={"CVV"} type={"text"} placeholder={"123"} value={cvv} setText={handleChangeCVV} hasButton={false}/>
                <FormInput id={"payment-form_cardExp"} label={"תוקף כרטיס האשראי"} type={"date"} placeholder={null} value={expiryDate} setText={setExpiryDate} hasButton={false} hasMin={true} min={getTodayDate}/>
                <FormButton disabled={paymentFlag} text={"בצע תשלום"} action={()=>{handleCreateWebsite(nav, getTodayDate)}}/>
        </div>
    );
}
